<template>
  <div id="app">
    <router-view/>
    <Toast />
    <SplashScreen />
  </div>
</template>

<script setup>
import { computed, watch, onMounted } from 'vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import Toast from '@/components/common/Toast.vue'
import SplashScreen from '@/components/elements/SplashScreen.vue'
import api from '@/api/api'

const store = useStore()
const route = useRoute()
const theme = computed(() => store.state.theme)
const fontSize = computed(() => store.state.fontSize)

const applySettings = () => {
  const root = document.documentElement
  
  // Apply Font Size
  root.classList.remove('font-size-small', 'font-size-medium', 'font-size-large')
  root.classList.add(`font-size-${fontSize.value}`)

  // Apply Theme
  let targetTheme = theme.value
  if (theme.value === 'system') {
    targetTheme = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
  }
  root.setAttribute('data-theme', targetTheme)
}

// Watch for changes
watch([theme, fontSize], applySettings)

const initGlobalData = () => {
  const currentPath = window.location.pathname
  const isPublicPage = ['/', '/rePwd', '/error'].includes(currentPath)

  if (store.state.userStore.accToken && !isPublicPage) {
    // 유저 정보 최신화
    api.postUserInfo()
      .then(res => {
        if (res.data.result) {
          store.commit('userStore/saveUsrInfo', res.data.data.usrInf)
        } else {
          store.commit('userStore/initData')
          if (currentPath !== '/') location.replace('/')
        }
      }).catch(() => {})
  }

  // 공통 코드 호출
  if (!isPublicPage && store.state.userStore.accToken) {
    store.dispatch('commonStore/getAnnualTypeList')
  }
}

// Watch for route changes to handle navigation from public to private pages
watch(() => route.path, initGlobalData)

onMounted(() => {
  applySettings()
  window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
    if (theme.value === 'system') applySettings()
  })

  initGlobalData()
})
</script>

<style>
/* Global resets if needed */
body {
  margin: 0;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
